/** `/c/$companyId/purchases/payments?tab&supplier&payFrom&method&from&to&q` — the supplier payments list. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PAYMENT_LIST_TABS, SUPPLIER_PAYMENT_METHODS } from "../api/codes";
import { CODE_SETS } from "../ledger/books";
import { PaymentsList } from "../payments/list/PaymentsList";
import { CodeGate } from "../shell/CodeGate";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const search = z.object({
  tab: z.enum(PAYMENT_LIST_TABS).optional().catch(undefined),
  supplier: z.string().uuid().optional().catch(undefined),
  payFrom: z.string().uuid().optional().catch(undefined),
  method: z.enum(SUPPLIER_PAYMENT_METHODS).optional().catch(undefined),
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/payments/")({
  validateSearch: (raw) => search.parse(raw),
  component: PaymentsRoute,
});

function PaymentsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.PR}>
      <PaymentsList
        companyId={companyId}
        search={search}
        onSearch={(next) =>
          void navigate({
            search: { ...next, tab: PAYMENT_LIST_TABS.find((id) => id === next.tab) },
            replace: true,
          })
        }
      />
    </CodeGate>
  );
}
